<template>
  <div>
    <el-row class="container" style="margin-top: 15px;" :gutter="20">
      <div v-bind:class="`comentario ${depth !== 0 ? 'respuesta' : ''}`" v-bind:style="indent">
        <el-row>
          <el-col :span="20" class="user">{{comentario.Usuario.NombreUsuario}}</el-col>
          <el-col :span="4" class="fecha">{{comentario.FechaRegistroStr}}</el-col>
        </el-row>
        
        <el-row>
          <el-col :span="24" class="body_comentario">{{comentario.Comentario}}</el-col>
        </el-row>
        
        <el-row v-if="comentario.Imagenes.length > 0">
          <el-col :span="24">
            <div class="images">
              <el-carousel indicator-position="outside" height="467px" :interval="10000" >
                  <el-carousel-item
                    v-for="(imagen, index) in comentario.Imagenes"
                    :key="index"
                  >
                    <img class="img" :src="imagen" />
                  </el-carousel-item>
                </el-carousel>
            </div>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="4">
            <div class="container_btn-responder" ref="btn_response" @click="onClickResponder">
              <span class="btn-responder"><i class="el-icon-chat-dot-square icon"></i>{{$t('FORO_responder')}}</span>
            </div>
          </el-col>
          <el-col :span="20">
            <div class="container_btn-responder" @click="toggleShowRespuestas">
              <span v-if="respuestas.length > 0" class="btn-responder"><i class="el-icon-chat-line-square icon"></i>{{respuestas.length}}</span>
            </div>
          </el-col>
        </el-row>

      <div v-if="showNewRespuesta" ref="response" class="leave_comment">
        <Respuesta 
          :idForo="idForo"
          :idComentario="comentario.Id" 
          :afterSave="afterSaveRespuesta"
          esRespuesta 
          @closeRespuesta="closeRespuesta"
          :permitirImagenes="permitirImagenes" 
        />
      </div>

      <div class="divider">
      </div>

      <div v-if="showRespuestas">
        <Comentario v-for="respuesta in respuestas" :comentario="respuesta" :permitirImagenes="permitirImagenes" :idForo="idForo" :key="respuesta.Id" :depth="depth + 1" />
      </div>
    </div>
    </el-row>
  </div>
</template>

<script>
import Respuesta from '@/components/Foro/respuesta'

export default {
  name: 'Comentario',
  components: { Respuesta },
  props: ['comentario', 'depth', 'idForo', 'permitirImagenes'],
  data() {
    return {
      respuestas: this.comentario.Respuestas,
      showRespuestas: false,
      showNewRespuesta: false
    }
  },

  created() {
    window.addEventListener('click', this.onClick)
  },

  beforeDestroy() {
    window.removeEventListener('click', this.onClick)
  },

  methods: {
    toggleShowRespuestas() {
      this.showRespuestas = !this.showRespuestas
    },

    onClickResponder() {
      this.showNewRespuesta = true
    },

    closeRespuesta() {
      this.showNewRespuesta = false
    },

    onClick(e) 
    {
      if(!this.$refs.btn_response.contains(e.target))
      {
        if(this.$refs.response && !this.$refs.response.contains(e.target) && this.showNewRespuesta)
        {
          this.closeRespuesta()
        }
      }
    },

    afterSaveRespuesta(newRespuesta) {
      this.respuestas.push(newRespuesta)
      this.closeRespuesta()
      this.showRespuestas = true
    }
  },
  computed: {
    indent() {
      let paddingHorizontal = 10 + (5 * this.depth)

      return { padding: `5px ${paddingHorizontal}px` }
    }
  },
}
</script>

<style scoped>

  .container.el-row {
    margin-top: 5px !important;
  }

  .comentarios {
    margin: 20px auto;
    width: 95%;
  }

  .comentario.respuesta {
    border-left: 1px solid #7fc5dc;
    margin-left: 20px;
    background-color: var(--main-color)0d;
  }

  .user {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: var(--main-color);
    float: left;
    margin-bottom: 5px;
    text-align: left;
  }
  .comentario.respuesta .user {
    font-size: 13px;
  }

  .fecha {
    font-size: 14px;
    line-height: 16px;
    float: right;
    text-align: right;
  }
  .comentario.respuesta .fecha {
    font-size: 12px;
  }

  .body_comentario {
    clear: both;
    font-size: 14px;
    line-height: 19px;
    color: rgb(90, 90, 90);
    text-align: left;
  }
  .comentario.respuesta .body_comentario {
    font-size: 13px;
  }

  .images {
  max-height: 485px;
  margin-top: 20px;
}
.img {
  max-width: 900px;
  height: 465px;
  max-height: 465px;
  margin: 0 50px;
}

  .container_btn-responder {
    margin-top: 20px;
    text-align: left;
  }

  .btn-responder {
    color: #6F6F6F;
    font-size: 14px;
    top: 5px;
    cursor: pointer;
    /* font-weight: bold; */
  }
  .btn-responder:hover {
    color: var(--main-color);
  }
  .comentario.respuesta .btn-responder {
    font-size: 14px;
  }

  .divider {
    border-bottom: 1px dotted #C4C4C4;
    display: inline-block;
    width: 100%;
  }

  .icon {
    margin-right: 10px;
  }
  .leave_comment {
    margin: 20px auto;
  }
</style>
<style>
.el-carousel__indicators--outside button {
    background-color: #2057c6;
    opacity: .40;
}
</style>
